// User
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const UPDATE_AVAILABLE_ORGANIZATIONS = "UPDATE_AVAILABLE_ORGANIZATIONS";
export const UPDATE_SELECTED_ORGANIZATION = "UPDATE_SELECTED_ORGANIZATION";